// utils/queryGeneration.ts
import { getTypeString, isGQLScalarType } from "../baseqlTypes";
import { metaDataStore } from "../metaDataStore";
var generateOperationString = (opType, op, gqlFields = "") => `
    ${opType}${variableDefinition(op.params)} {
      ${op.name}${operationParameters(op.params)}${directives(op)} ${gqlFields}
    }
`;
var variableDefinition = (params) => params.length ? "(" + params.reduce(
  (acc, param, index) => acc + (index === 0 ? "" : ", ") + "$" + param.name + ": " + "[".repeat(param.arrayDepth()) + getTypeString(param.type, true) + "]".repeat(param.arrayDepth()),
  ""
) + ")" : "";
var operationParameters = (params) => params.length ? "(" + params.reduce((acc, param, index) => acc + (index === 0 ? "" : ", ") + param.name + ": $" + param.name, "") + ")" : "";
var directives = (op) => "";
var selectionSet = (op, depth, blacklist = []) => {
  return allFieldsSelectionSet(op, depth, blacklist);
};
var allFieldsSelectionSet = (op, depth, blacklist = [], inlineFragment) => {
  if (!depth || isGQLScalarType(typeof op === "function" ? op : op.type))
    return "";
  const opNode = typeof op === "function" ? metaDataStore.find((node) => node.type() === op()) : op;
  if (!opNode)
    throw new Error(`Cannot find node for return type ${getTypeString(typeof op === "function" ? op : op.type)}`);
  return "{ " + metaDataStore.getAllFields(opNode, -1).reduce(
    (acc, field) => depth - 1 === 0 && !isGQLScalarType(field.type) || blacklist.includes(field.name) ? acc : `${acc} ${field.name} ${allFieldsSelectionSet(field.type, depth - 1, blacklist, false)}`,
    ""
  ) + (inlineFragment ? "" : metaDataStore.reduce(
    (acc, node, d) => d ? `${acc} ... on ${getTypeString(node.type)} ${allFieldsSelectionSet(node, depth, blacklist, true)}` : "",
    "",
    opNode
  )) + " }";
};
export {
  generateOperationString,
  selectionSet
};
